module.exports = __webpack_public_path__ + "static/media/trussardi-donna.434349e5.png";